import { Injectable } from '@angular/core';
import { AnalyticsArguments, AnalyticsService } from '@reef/core';

/**
 * An analytics service implementation that doesn't do anything
 */
@Injectable({
  providedIn: 'root'
})
export class DummyAnalyticsService implements AnalyticsService {

  track(_args: AnalyticsArguments): void {
  }

  stopTimer(_action: string): void {
  }

  setURI(_restURI: string): void {
  }

}
